import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

import Colors from '../resource/ResourceColors.jsx';

const BUTTON_BACKGROUND = Colors.right_diagonal_gradient(100, 80);
const BUTTON_BACKGROUND_HOVER = Colors.right_diagonal_gradient(80, 60)
const BUTTON_SHADOW_BLUR = Colors.wide_raw_shadow(50);
const BUTTON_SHADOW_TIGHT = Colors.tight_raw_shadow(70)

const ControlButton = styled.div`
    color: ${Colors.primary(50)};
    padding: 0.1rem 0.75rem;
    text-align: center;
    vertical-align: middle;
    float: right;
    font-size: 0.75rem;    
    text-transform: uppercase;
    border-radius: 0.25rem;
    margin-right: 1rem;
    margin-top: 0.15rem;
    background: ${BUTTON_BACKGROUND};    
    box-shadow: ${BUTTON_SHADOW_BLUR}, ${BUTTON_SHADOW_TIGHT};    
`;

const ControlText = styled.div`
    color: ${Colors.grey(70)}
`;

export class UtilControl extends Component {

    static propTypes = {
        type: PropTypes.oneOf(['text', 'button']).isRequired,
        label: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        handler: PropTypes.func.isRequired,
        default: PropTypes.bool,
        width: PropTypes.string,
        value: PropTypes.string,
    }

    static defaultProps = {
        minWidth: '3.5rem',
        default: false,
    }

    state = {
        selected: false,
        in_hover: false,
        in_mousedown: null
    };

    on_mouseup(e) {
        if (this.state.in_mousedown) {
            this.props.handler(e);
        }
        this.setState({in_mousedown: false});
    }

    render_button() {
        const button_style = {
            width: this.props.width
        }
        if (this.state.in_hover) {
            button_style.color = 'white';
            button_style.fontWeight = 'bold';
            button_style.background = BUTTON_BACKGROUND_HOVER;
            button_style.textShadow = Colors.tight_text_shadow(20);
        }
        if (this.state.in_mousedown) {
            button_style.marginTop = '0.20rem';
            button_style.boxShadow = BUTTON_SHADOW_TIGHT;
        }
        return <ControlButton
            style={button_style}
            onMouseDown={(e) => this.setState({in_mousedown: true})}
            onMouseUp={(e) => this.on_mouseup(e)}
            onMouseOver={(e) => this.setState({in_hover: true})}
            onMouseOut={(e) => this.setState({in_hover: false, in_mousedown: false})}>
            {this.props.label}
        </ControlButton>
    }

    render_text() {
        return <ControlText>
            {this.props.label}
        </ControlText>
    }

    render() {
        switch (this.props.type) {
            case 'button':
                return this.render_button();
            case 'text':
                return this.render_text();
            default:
                return <div>control {this.props.type} not found</div>
        }
    }
}

export default UtilControl;
